import React, { Component } from 'react';
import './EpochWechatID.css'

import wechat_qrcode from '../images/epoch_wechat.jpg';

class EpochWechatID extends Component {

  render() {
    return (
      <div className='container'>
        <div className='imageWrapper'>
          <img src={wechat_qrcode} alt="Epoch Wechat ID" className='containerImg' style={{borderRadius: 16}}/>
        </div>
      </div>
    );
  }
}

export default EpochWechatID